import { GAReplacementValue, Position } from 'constants/enums';
import type { Psychic } from 'src/__generated__/graphqlTypes';
import type { RightPsychic } from 'types/objectTypes';

export type UseProfileLinkResponse = {
  profileLink: Psychic['profileButton'];
  profileUrl: string;
  gaData: {
    [GAReplacementValue.PSYCHIC_NAME]: string;
    [GAReplacementValue.POSITION]: string;
  };
}

export const useProfileLink = (
  psychicFrame: Psychic,
  psychic: RightPsychic,
  position: Position | '' = '',
): UseProfileLinkResponse => {
  const profileLink = psychicFrame.profileButton;
  const finalProfileLink = (psychicFrame?.profileButton?.src)
    ? psychicFrame.profileButton.src + psychic.psychicBioURL
    : psychic.psychicBioURL;
  const { _meta: meta = {} } = profileLink?.gaProperties || {};

  return {
    profileLink,
    profileUrl: finalProfileLink,
    gaData: {
      [GAReplacementValue.PSYCHIC_NAME]: psychic.lineName,
      [GAReplacementValue.POSITION]: meta[position],
    },
  };
};
